export class WorkplaceService {
    static $inject = ['MessagingHubService'];
    constructor(MessagingHubService) {
        this.MessagingHubService = MessagingHubService;
        this.workplaceGatewayIdentity = 'postmaster@workplace.gw.msging.net';
    }
    async getTokenInfo(code, redirectUri) {
        const tokenCommandRequest = {
            method: 'set',
            type: 'application/vnd.iris.facebook.authorization-code+json',
            to: this.workplaceGatewayIdentity,
            uri: '/token',
            resource: {
                code: code,
                redirectUri: redirectUri,
            },
        };
        return await this.MessagingHubService.processCommand(tokenCommandRequest);
    }
}
WorkplaceService.$inject = ['MessagingHubService'];
